//
//
//
//
//
//

export default {
    props: {
        title: {
            type: String,
            default: '购房通承诺'
        }
    }
}
